export enum SeriesTitles {
  VIEWS = "VIEWS",
  UNIQUE_CONSUMERS = "UNIQUE_CONSUMERS",
  //CLICKS ="CLICKS",
  COMPLETED = "COMPLETED",
  CONSUMERS = "CONSUMERS",
  CLICKS = "CLICKS",
}
export enum SeriesTitlesToShow {
  VIEWS = "Charts.views",
  UNIQUE_CONSUMERS = "Charts.uniqueConsumers",
  //CLICKS = "Clicks",
  COMPLETED = "Charts.completed",
  CONSUMERS = "Charts.consumers",
  CLICKS = "Charts.clicks",
}
export interface SeriesTitlesInterface {
  id: SeriesTitles;
  value: string;
}
